import { useEffect, useState } from 'react'
import type { Choice } from '../../components/Contexts/AdaptiveCardContext'

const useValues = (instanceId?: string): Map<string, string | number | Array<string> | Array<number> | Choice | boolean> => {
  const [current, setCurrent] = useState<Map<string, string | number | Array<string> | Array<number> | Choice | boolean>>(new Map())

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_values', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_values'))

    return () => {
      document.removeEventListener('retorik_values', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useValues
